import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getDevData } from "../../services/generalService";
import { BillsReversalObj } from "../../utils/types";

const initialState: BillsReversalObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getAllBillsReversalData = createAsyncThunk(
  "getAllBillsReversal",
  async (url: string, thunkAPI) => {
    try {
      const data = await getDevData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const billsReversalSlice = createSlice({
  name: "billsReversal",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllBillsReversalData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllBillsReversalData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getAllBillsReversalData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default billsReversalSlice.reducer;
